<ng-container [ngSwitch]="emojiType">
  <ng-container *ngSwitchCase="'emoji'">
    <span class="emoji" [style]="emojiAsSprite"></span>
  </ng-container>
  <ng-container *ngSwitchCase="'native'">
    <span class="emoji" [innerHtml]="nativeEmoji" [style.font-size.px]="spriteEmojiSize"></span>
  </ng-container>
</ng-container>
